import { Log } from '@core';
import { filter, first, Observable, of, tap } from 'rxjs';
import { StartupState } from '../startup.state';
import { inject } from '@angular/core';
import { StartupStep } from '../startup-step';
import { NotificationsInitializer } from '@notifications';

export class NotificationsStep extends StartupStep {
  private readonly notificationInitializer: NotificationsInitializer = inject(NotificationsInitializer);

  executeStep(state: StartupState): Observable<StartupState> {
    this.logger.log(Log.Startup, { message: 'NotificationsStep START' });
    state.authed$
      ?.pipe(
        filter(Boolean),
        first(),
        tap(() => this.notificationInitializer.init()),
        tap(() => this.logger.log(Log.Startup, { message: 'NotificationsStep COMPLETED' }))
      )
      .subscribe();

    return of(state);
  }
}
